// Shared "g-prefix is armed" state for keyboard shortcuts.
// ShortcutsCheatsheet sets this when the user presses `g`; other shortcut
// listeners (QuickCreateMenu's `c`) check it to avoid double-firing.
const state = { armedAt: 0 };
const WINDOW_MS = 1200;

export function armGNav() {
  state.armedAt = Date.now();
}

export function clearGNav() {
  state.armedAt = 0;
}

export function isGNavArmed() {
  return state.armedAt > 0 && Date.now() - state.armedAt < WINDOW_MS;
}
